import { createRouter } from "@tanstack/react-router";

import { RouteErrorComponent } from "@/components/organisms/ErrorBoundary/RouteErrorComponent";
import { alertsRoute } from "@/pages/Alerts/route";
import { documentationRoute } from "@/pages/Documentation/route";
import { homeRoute } from "@/pages/Home/route";
import { loginRoute } from "@/pages/Login/route";
import { plantConfigurationRoute } from "@/pages/PlantConfiguration/route";
import { plantConfigurationVersionRoute } from "@/pages/PlantConfiguration/versionRoute";
import { plantAnalysisRoute } from "@/pages/PlantDetail/analysisRoute";
import { plantDashboardRoute } from "@/pages/PlantDetail/dashboardRoute";
import { plantPerformanceRoute } from "@/pages/PlantDetail/performanceRoute";
import {
  plantDetailIndexRoute,
  plantDetailLayoutRoute,
  plantDetailRoute,
} from "@/pages/PlantDetail/route";
import { plantHsuDetailRoute } from "@/pages/PlantHsuDetail/route";
import {
  plantNcuDetailIndexRoute,
  plantNcuDetailRoute,
} from "@/pages/PlantNcuDetail/route";
import { plantsIndexRoute, plantsRoute } from "@/pages/Plants/route";
import { plantTcuDetailRoute } from "@/pages/PlantTcuDetail/route";
import { rootRoute } from "@/routes/rootRoute";

/** @internal */
export const routeTree = rootRoute.addChildren([
  loginRoute,
  documentationRoute,
  alertsRoute,
  homeRoute,
  plantsRoute.addChildren([
    plantsIndexRoute,
    plantDetailRoute.addChildren([
      plantDetailLayoutRoute.addChildren([
        plantDetailIndexRoute,
        plantAnalysisRoute,
        plantDashboardRoute,
        plantPerformanceRoute,
      ]),
      plantNcuDetailRoute.addChildren([
        plantNcuDetailIndexRoute,
        plantTcuDetailRoute,
        plantHsuDetailRoute,
      ]),
      plantConfigurationRoute,
      plantConfigurationVersionRoute,
    ]),
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultErrorComponent: RouteErrorComponent,
});

// Contentsquare: enviar pageview en cada cambio de ruta (requerido para SPAs)
if (import.meta.env.VITE_CONTENTSQUARE_CLIENT_ID) {
  router.subscribe("onResolved", ({ toLocation }) => {
    window._uxa = window._uxa || [];
    window._uxa.push(["setPath", toLocation.pathname + toLocation.searchStr]);
    window._uxa.push(["trackPageview"]);
  });
}

export type Router = typeof router;

declare module "@tanstack/react-router" {
  interface Register {
    router: Router;
  }

  // Cada ruta que aporta una miga declara su tipo de crumb; useBreadcrumbs
  // recorre los matches y resuelve la etiqueta de cada uno (ver useBreadcrumbs).
  interface StaticDataRouteOption {
    crumb?: "plants" | "plantName" | "ncu" | "tcu" | "hsu";
  }

  interface HistoryState {
    openActivationForm?: boolean;
  }
}
